/**
 * Logger for aven_shared, shared across Aven frontend bundles.
 *
 * The legacy Vue logger (LogLevel, `Logger` class, `logger` instance) has been
 * removed. The canonical frontend logger is `log`, created via `createLogger`
 * from `./otel/logger` (pino-browser + batched transport).
 */
import utilInspect from 'browser-util-inspect'

import { createLogger } from './otel/logger'

export const inspect = (msg: unknown) => {
    return utilInspect(msg)?.replace(/[\s]*[\n][\s]*/g, '; ')
}

export const log = createLogger({
    avenProject: 'shared',
    logProcessorBaseUrl: process.env.VUE_APP_LOGGER_BASE_URL ? process.env.VUE_APP_LOGGER_BASE_URL.replace(/\/logs\/?$/, '/client-logs') : undefined,
    clientSideLogsEnabled: process.env.VUE_APP_CLIENT_SIDE_LOGS_ENABLED === 'yes',
    getContext: () => {
        return {}
    },
})
